module.exports = "../fonts/HelveticaNeueLTW01-75Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-75Bold.eot
// module id = TN9k
// module chunks = 1